var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-flex-col tw-flex-1"},[_c('div',{staticClass:"tw-flex-1 tw-relative"},[_c('div',{staticClass:"sm:tw-absolute sm:tw-overflow-y-auto tw-h-full tw-w-full"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }